import { formatToString } from '@/utils/libs/date-fns/format';
/**
 * form の値を送信用の値に変換する
 */
export const getHotlineClientCreateSubmitValues = (formValue) => {
    const { adviceRequest, interviewRequestedFromAt, interviewRequestedToAt } = formValue;
    return Object.assign(Object.assign({}, formValue), { advice_request: adviceRequest, interview_requested_from_at: formatToString({
            formatString: 'yyyy-MM-dd HH:mm:ss',
            value: interviewRequestedFromAt,
        }), interview_requested_to_at: formatToString({
            formatString: 'yyyy-MM-dd HH:mm:ss',
            value: interviewRequestedToAt,
        }) });
};
